import { Chip } from 'primereact/chip';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

const Footer = ({ eventData }) => {
  const navigate = useNavigate();
  const goToInformationInterest = (origin) => {
    navigate(`/information_interest?origin=${origin}`);
  };
  return (
    //  Information of interest
    <div
      style={{
        paddingTop: 12,
        paddingRight: 16,
        paddingBottom: 12,
        paddingLeft: 24,
        marginTop: 22,
        width: eventData.width,
        minHeight: eventData.height * 0.15,
        backgroundColor: 'var(--gray-600)',
        borderRadius: 0,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
      }}
      id="footer"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
        className="descriptionContainer"
      >
        <div
          style={{
            width: eventData.width * 0.45,
            fontWeight: 600,
            backgroundColor: 'var(--gray-700)',
            padding: 16,
            borderRadius: 5,
          }}
          className="description first"
        >
          <p style={{ fontWeight: 600 }}>Información de interés</p>
          <div className="informationInterestLinks">
            <div
              onClick={() => goToInformationInterest('termsOfService')}
              className="infoInterestLink"
            >
              Términos del Servicio
            </div>
            <div
              onClick={() => goToInformationInterest('refundPolicy')}
              className="infoInterestLink"
            >
              Política de Reembolso
            </div>
            <div
              onClick={() => goToInformationInterest('shipping')}
              className="infoInterestLink"
            >
              Envíos
            </div>
            <div
              onClick={() => goToInformationInterest('legalInformation')}
              className="infoInterestLink"
            >
              Información Legal
            </div>
            <div
              onClick={() => goToInformationInterest('contact')}
              className="infoInterestLink"
            >
              Contacto
            </div>
          </div>
        </div>
        {/* Social infornation */}
        <div
          style={{
            width: eventData.width * 0.45,
            backgroundColor: 'var(--gray-700)',
            padding: 16,
            borderRadius: 5,
          }}
          className="description"
        >
          <p style={{ fontWeight: 600 }}>Pagos y envíos</p>
          <p style={{ paddingTop: 16 }}>
            Podrás adquirir obras de{' '}
            <span style={{ fontWeight: 600 }}>Dio</span> por medio de
            transferencia bancaria, tarjetas de crédito y débito por medio de
            mercadopago. Realizamos envíos nacionales e internacionales.
          </p>
        </div>
      </div>
      <div style={{ paddingTop: 16, display: 'flex' }}>
        <div
          style={{
            display: 'flex',
            flex: 1,
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
          className="descriptionContainer"
        >
          <Chip
            label="Sigueme en:"
            image="https://dioart-low.s3.us-east-1.amazonaws.com/6fa4601ec61f91bc113c6ac689807f97-c5-1080x1080.jpg"
            className="chip"
          />
          <div
            style={{
              display: 'flex',
              width: 250,
              justifyContent: 'space-around',
            }}
            className="socialMedia"
          >
            <a
              href="https://www.instagram.com/artwithdio"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="pi pi-instagram icon"
                style={{ fontSize: '1.5rem' }}
              ></i>
            </a>
            <a
              href="https://www.tiktok.com/@artwithdio"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="pi pi-tiktok icon"
                style={{ fontSize: '1.5rem' }}
              ></i>
            </a>
            <a
              href="https://www.threads.net/@artwithdio"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="fa-brands fa-threads icon"
                style={{ fontSize: '1.5rem' }}
              ></i>
            </a>
            <a
              href="https://wa.me/+5491127191959"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="pi pi-whatsapp icon"
                style={{ fontSize: '1.5rem' }}
              ></i>
            </a>
            <a
              href="https://twitter.com/dioart_"
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="pi pi-twitter icon"
                style={{ fontSize: '1.5rem' }}
              ></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
